import React, { useEffect, useState } from 'react';
import './StoreSettings.scss';
import { Box, Button, FormControlLabel, Switch, TextField } from '@mui/material'
import StorefrontIcon from '@mui/icons-material/Storefront';
import { useSettings } from '../../../hook/useSettings';
import { InfoApp } from './InfoApp';
import BusinessHoursEditor from './BusinessHoursEditor';
import InfoHours from './InfoHours';

export function StoreSettings({dataSettings}) {

    const [activeTab, setActiveTab] = useState(0);


    const tabs = [
      { title: 'Datos del Negocio', description: 'Modifica la información de tu negocio' },
      { title: 'Horarios', description: 'Configura los horarios donde recibirás pedidos' },
      { title: 'Tab 3', description: 'Content of Tab 3' },
    ];
  
    return (
      <div className="vertical-tabs">
        <div className="tab-list cl-25">
          {tabs.map((tab, index) => (
            <>
            <div
              key={index}
              className={`tab-item ${index === activeTab ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
            <div className="icon_stt">
               <StorefrontIcon/>
            </div>
            <div className="title_stt">
            <h4>{tab.title}</h4>
            <p>{tab.description}</p>
            </div>
            
            </div>
            </>
          ))}
        </div>
        <div className="tab-content">
          <div className={`tab-content-item ${0 === activeTab ? 'active' : ''}`}>
            <InfoApp dataSettings={dataSettings}/>
          </div>
          <div className={`tab-content-item ${1 === activeTab ? 'active' : ''}`}>
            <InfoHours />
          </div>
          <div className={`tab-content-item ${2 === activeTab ? 'active' : ''}`}>
            <ScheduleApp />
          </div>
        </div>
      </div>
    );

}




function ScheduleApp(){
  return(
    <h1>info local</h1>
  )
}



